import { useCallback } from "react";
import { gsapFactory } from "../../core/gsapFactory";
import { EaseOptions, SharedOpts } from "../../core/index.types";


export type BlurOpts = SharedOpts & {
  show?: boolean;
  amount: number;
  throttle?: number;
  ease?: EaseOptions;
};

export function useGsapBlur() {
  return useCallback((el: HTMLElement | null, opts: BlurOpts, id?: string) => {

    if (!el) throw new Error("Missing Blur Target");

    const { amount, duration = 0.6, ease = EaseOptions.Power2Out, yoyo = false, throttle = 0, repeat = 0 } = opts; //prettier-ignore

    let frame = 0;
    const clampedThrottle = Math.max(1, Math.floor(throttle));

    const t = gsapFactory.to(el, {
      duration,
      ease,
      yoyo,
      repeat,
      onStart: () => {
        frame = 0;
        el.style.willChange = "filter";
        el.style.setProperty("filter", el.style.filter, "important");
      },
      onComplete: () => {
        el.style.setProperty("filter", el.style.filter, "important");
        el.style.willChange = "";
      },
      onUpdate: () => {
        frame++
        const test = frame % clampedThrottle;
        if (test !== 0) return;
        const blur = amount * t.progress();
        el.style.filter = `blur(${blur}px)`;
        el.style.setProperty("filter", el.style.filter, "important");
      },
    }, id)

    return t
  }, []);
}
